import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
export function ReportsMenu() {
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to the new Diagnostics landing page
    navigate('/diagnostics', {
      replace: true
    });
  }, [navigate]);
  return <>
      <Helmet data-id="element-3679">
        <title data-id="element-3680">Redirecting... | Lazy Monk Labs</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-3681" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center" data-id="element-3682">
        <p className="text-base text-gray-500" data-id="element-3683">Redirecting...</p>
      </div>
    </>;
}